<div *ngIf="!loading else loadingTemplate" class="d-flex flex-column h-100" #calendarContainer>
  <mat-toolbar class="bg-white h-auto">
    <div class="row no-gutters w-100">
      <div class="col-lg-8 col-md-12 col-12 d-flex align-items-center">
        <div class="row w-100">
          <div class="col-md-auto col">
            <button mat-stroked-button aria-label="refresh total shipments" (click)="getUpdateEvents()">
              <mat-icon class="align-baseline" fontSet="fas" fontIcon="fa-sync"></mat-icon>
              Total Vessel Events: {{ events.length }}
            </button>
          </div>
          <div class="col">
            <button class="exclude-export" mat-icon-button aria-label="download pdf" matTooltip="Download PDF" (click)="printCalendar()">
              <mat-icon fontSet="far" fontIcon="fa-file-pdf"></mat-icon>
            </button>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="row no-gutters">
          <div class="col d-flex flex-column">
            <div class="d-flex m-2">
              <span class="mp-check-filter type-scheduled">S</span>
              <span class="legend-item ml-1">Scheduled</span>
            </div>
            <div class="d-flex m-2">
              <span class="mp-check-filter type-nominated">N</span>
              <span class="legend-item ml-1">Nominated</span>
            </div>
          </div>
          <div class="col d-flex flex-column">
            <div class="d-flex m-2">
              <span class="mp-check-filter type-partially-permitted">P</span>
              <span class="legend-item ml-1">Partially Permitted</span>
            </div>
            <div class="d-flex m-2">
              <span class="mp-check-filter type-fully-permitted">F</span>
              <span class="legend-item ml-1">Fully Permitted</span>
            </div>
          </div>
          <div class="col d-flex flex-column">
            <div class="d-flex m-2">
              <span class="mp-check-filter type-loading-commenced">L</span>
              <span class="legend-item  ml-1">Loading Commenced</span>
            </div>
            <div class="d-flex m-2">
              <span class="mp-check-filter type-loading-completed">C</span>
              <span class="legend-item ml-1">Loading Completed</span>
            </div>
          </div>
          <div class="col d-flex flex-column">
            <div class="d-flex m-2">
              <span class="mp-check-filter type-cancelled">X</span>
              <span class="legend-item ml-1">Cancelled</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-toolbar>
  <mat-toolbar class="bg-white">
    <div class="d-flex">
      <button mat-stroked-button class="exclude-export" aria-label="previous month" mwlCalendarPreviousView [view]="'month'"
              [(viewDate)]="currentDate"
              (click)="getUpdateEvents()">
        <mat-icon class="align-baseline" fontSet="fas" fontIcon="fa-angle-double-left"></mat-icon>
        <span class="d-none d-sm-inline-block">Previous Month</span>
      </button>
      <button mat-stroked-button class="ml-2 exclude-export" aria-label="previous month" mwlCalendarToday [(viewDate)]="currentDate"
              (click)="getUpdateEvents()">
        Current Month
      </button>
    </div>
    <span class="filler text-center">{{ currentDate | calendarDate:('monthViewTitle') }}</span>
    <div class="d-flex">
      <button mat-stroked-button class="exclude-export" aria-label="current month" mwlCalendarToday [(viewDate)]="currentDate"
              (click)="getUpdateEvents()">Current Month
      </button>
      <button mat-stroked-button class="ml-2 exclude-export" aria-label="next month" mwlCalendarNextView [view]="'month'" [(viewDate)]="currentDate"
              (click)="getUpdateEvents()">
        <span class="d-none d-sm-inline-block">Next Month</span>
        <mat-icon class="align-baseline" fontSet="fas" fontIcon="fa-angle-double-right"></mat-icon>
      </button>
    </div>
  </mat-toolbar>
  <div class="d-flex flex-grow-1 bg-white">
    <ng-container *ngIf="!loading else loadingTemplate">
      <mwl-calendar-month-view
        class="flex-fill"
        [viewDate]="currentDate"
        [events]="calendarEvents"
        [cellTemplate]="customCellTemplate"
        (eventClicked)="handleEventClick($event.event)"
        (beforeViewRender)="blockDays($event)">
      </mwl-calendar-month-view>
    </ng-container>
  </div>
</div>

<ng-template #customCellTemplate let-day="day" let-locale="locale" let-eventClicked="eventClicked">
  <div class="cal-cell-top">
    <span class="cal-day-number" [ngClass]="{ 'cal-cell-day-muted': (day.isPast || day.isFuture ) && !day.inMonth }">
      {{ day.date | calendarDate:'monthViewDayNumber' : locale }}
    </span>
  </div>
  <ng-container *ngIf="day.events.length > 0">
    <div class="cal-cell-row flex-column p-1">
      <div class="cal-ut-event" *ngFor="let event of day.events" (mwlClick)="eventClicked.emit({ event: event })">
        <div class="d-flex justify-content-between">
          <strong>{{ event.title }}</strong>
          <span>{{ event.meta.tonnage }}</span>
        </div>
        <div class="d-flex justify-content-between">
          <span>{{ event.meta.finalCustomer }}</span>
          <ng-container [ngTemplateOutlet]="eventStatusTpl"
                        [ngTemplateOutletContext]="{ status: event.meta.status }">
          </ng-container>
        </div>
        <div class="d-flex justify-content-between" *ngFor="let nominee of event.meta.nominees">
          <span>{{ nominee.nomineeName }}</span>
          <span>{{ nominee.tonsRequested }}</span>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #loadingTemplate>
  <ns-skeleton [type]="skeleton"></ns-skeleton>
</ng-template>

<ng-template #eventStatusTpl let-status='status'>
  <ng-container [ngSwitch]="status">
    <ng-container *ngSwitchCase="'S'">
      <span class="mp-check-filter type-scheduled m-1">S</span>
    </ng-container>
    <ng-container *ngSwitchCase="'P'">
      <span class="mp-check-filter type-partially-permitted m-1">P</span>
    </ng-container>
    <ng-container *ngSwitchCase="'L'">
      <span class="mp-check-filter type-loading-commenced m-1">L</span>
    </ng-container>
    <ng-container *ngSwitchCase="'X'">
      <span class="mp-check-filter type-cancelled m-1">X</span>
    </ng-container>
    <ng-container *ngSwitchCase="'N'">
      <span class="mp-check-filter type-nominated m-1">N</span>
    </ng-container>
    <ng-container *ngSwitchCase="'F'">
      <span class="mp-check-filter type-fully-permitted m-1">F</span>
    </ng-container>
    <ng-container *ngSwitchCase="'C'">
      <span class="mp-check-filter type-loading-completed m-1">C</span>
    </ng-container>
  </ng-container>
</ng-template>

